export default __webpack_public_path__ + "2f585c0604382cb54d7733b82824b670.svg";